import { COMPARE_PATHS } from "@/core/seo/prerender"

import { driversnoteAlternative } from "./driversnote"

export { COMPARE_PATHS, COMPARE_PUBLISHED } from "@/core/seo/prerender"

import { hub } from "./hub"
import { SPREADSHEET_SOURCE } from "./spreadsheet"
import { lastReviewed } from "./validate"

/** The one "Last reviewed" date per page: sitemap lastmod, visible badge and JSON-LD dateModified. */
export const compareReviewed: Record<(typeof COMPARE_PATHS)[number], string> = {
  "/compare": lastReviewed(hub)!,
  "/compare/driversnote-alternative": lastReviewed(driversnoteAlternative)!,
  "/compare/spreadsheet-logbook": SPREADSHEET_SOURCE.checkedAt,
}
